import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth } from './AuthContext';
import Login from './pages/Login';
import Home from './pages/Home';
import Setup from './pages/Setup';
import Week from './pages/Week';
import Session from './pages/Session';
import SessionOverview from './pages/SessionOverview';
import Library from './pages/Library';
import History from './pages/History';
import MigrateWorkouts from './pages/MigrateWorkouts';
import BottomTabBar from './components/BottomTabBar';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg">
        <div className="text-lg text-light-ink dark:text-dark-ink font-plex">Loading...</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
}

function App() {
  const { user } = useAuth();

  return (
    <Router>
      <div className="min-h-screen bg-light-bg dark:bg-dark-bg pb-20">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/setup"
            element={
              <PrivateRoute>
                <Setup />
              </PrivateRoute>
            }
          />
          <Route
            path="/week"
            element={
              <PrivateRoute>
                <Week />
              </PrivateRoute>
            }
          />
          <Route
            path="/session/:day/overview"
            element={
              <PrivateRoute>
                <SessionOverview />
              </PrivateRoute>
            }
          />
          <Route
            path="/session/:day"
            element={
              <PrivateRoute>
                <Session />
              </PrivateRoute>
            }
          />
          <Route
            path="/library"
            element={
              <PrivateRoute>
                <Library />
              </PrivateRoute>
            }
          />
          <Route
            path="/history"
            element={
              <PrivateRoute>
                <History />
              </PrivateRoute>
            }
          />
          <Route
            path="/migrate-workouts"
            element={
              <PrivateRoute>
                <MigrateWorkouts />
              </PrivateRoute>
            }
          />
        </Routes>
        {user && <BottomTabBar />}
        <Toaster position="top-center" />
      </div>
    </Router>
  );
}

export default App;
